<template>
  <div class="container px-4">
    <br class="mt-4" />
    <CollapseCard
      :title="t('CL_WITHDRAWAL.UNLINK_ACCOUNT_SUBTITLE')"
      :fill="true"
      :collapsable="false"
      titleIcon="fa fa-trash"
      :boldTitle="true"
      :alertMode="true"
    >
      <div class="p-3 text-black fw-bold text-center fs-6">
        {{ FormatBankAccountHelper(clabeNumber) }}
      </div>
    </CollapseCard>

    <CollapseCard
      :title="t('CL_WITHDRAWAL.UNLINK_ACCOUNT_ATTENTION')"
      :fill="true"
      :collapsable="false"
      titleIcon="fa fa-triangle-exclamation"
      :boldTitle="true"
    >
      <div>
        <em>{{ t("CL_WITHDRAWAL.UNLINK_ACCOUNT_WARNING_TEXT") }}</em>
      </div>
    </CollapseCard>

    <div class="floating-btn-placeholder" />

    <div class="floating-btn">
      <Button
        id="btn-continue"
        class="text-center w-100 p-3"
        @click="clickBtn"
        :disabled="!clabeNumber"
        :alertMode="true"
      >
        <span class="text-white my-auto fw-bold">
          {{ t("CL_WITHDRAWAL.UNLINK_BANK_ACCOUNT") }}
        </span>
      </Button>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, onMounted } from "vue";
import { useI18n } from "@/apps/credit-line/composables/useI18n";
import CollapseCard from "@/apps/credit-line/components/CollapseCard.vue";
import Button from "@/apps/credit-line/components/Button.vue";
import { FormatBankAccountHelper } from "@/apps/credit-line/helpers/formatBankAccount.helper";
import logAnalyticsEvent from "@/apps/credit-line/services/google-analytics-events.service";
import AnalyticEvents from "@/shared-helpers/google-analytics-events.helper";

export default defineComponent({
  name: "UnlinkBankAccount",
  components: { Button, CollapseCard },
  emits: ["next", "setScreenTitle"],
  props: {
    clabeNumber: {
      type: String,
      default: "",
    },
  },
  setup() {
    const { t } = useI18n();

    onMounted(() => {
      logAnalyticsEvent(
        AnalyticEvents.CreditLine.ClabeScreenView,
        "Withdrawal"
      );
    });

    return {
      t,
      FormatBankAccountHelper,
    };
  },
  methods: {
    clickBtn() {
      this.$emit("next", this.clabeNumber);
    },
  },
  mounted() {
    this.$emit("setScreenTitle", this.t("CL_WITHDRAWAL.UNLINK_ACCOUNT_TITLE"));
  },
});
</script>

<style lang="scss" scoped>
@import "@/assets/scss/_constants.scss";
.floating-btn-placeholder,
.floating-btn {
  height: 80px;
  width: 100%;
}
.floating-btn {
  background-color: white;
  position: fixed;
  padding: 10px 20px;
  left: 0;
  bottom: 0;
  z-index: 200;
}
</style>
